exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".catalogue-card-wrapper {\n  width: 20%;\n}\n\n@media screen and (max-width: 1400px) {\n  .catalogue-card-wrapper {\n    width: 25%;\n  }\n}\n@media screen and (max-width: 1200px) {\n  .catalogue-card-wrapper {\n    width: 33.33333%;\n  }\n}\n@media screen and (max-width: 480px) {\n  .catalogue-card-wrapper {\n    width: 50%;\n  }\n}", ""]);

// exports
